import { getInstance } from '@/plugins/auth0'
import store from '@/store'
import accessHelper from '@/helpers/access.helper'


export const authGuard = (to, from, next) => {
  const authService = getInstance()

  const fn = async () => {
    if (authService.isAuthenticated) {
      const user = store.getters['user/currentUser']
      if (user) {
        await store.dispatch('userState/loadUserState')
        let currentUserAndProjectClaims = store.getters['user/currentUserAndProjectClaims']
        if (!currentUserAndProjectClaims) {
          await accessHelper.setCurrentUserAndProjectClaims()
          currentUserAndProjectClaims = store.getters['user/currentUserAndProjectClaims']
        }
        if (accessHelper.isRouteAvailableForCurrentUserAndProject(to.name, user, currentUserAndProjectClaims)) {
          return next()
        } else {
          return next({ name: 'accessDenied' })
        }
      } else {
        return next({ name: 'unauthorized' })
      }
    }
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
  }


  if (!authService.loading) {
    return fn()
  }

  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn()
    }
  })
}
